import React, { useRef } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import PainPoints from "../components/PainPoints";
import Process from "../components/Process";
import Testimonials from "../components/Testimonials";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

export default function Landing() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white">
      <Header />
      <Hero onCta={scrollToContact} />
      <PainPoints />
      <Process />
      <Testimonials />
      <ContactForm innerRef={contactRef} />
      <Footer />
    </div>
  );
}
